'use client';
import CheckoutModal from '@/components/checkout/CheckoutModal';
import { useState } from 'react';

interface MobileStickyCTAProps {
  price: string
  checkoutUrl: string
}

export default function MobileStickyCTA({ price, checkoutUrl }: MobileStickyCTAProps) {
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false)

  return (
    <>
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden">
      <div className="glass-panel border-t border-border/30 p-4">
        <div className="flex items-center justify-between gap-4">
          <div className="mono-data text-2xl font-bold text-foreground">
            {price}
          </div>
          <button
            onClick={() => setIsCheckoutOpen(true)}
            className="flex-1 px-6 py-3 bg-primary text-primary-foreground mono-data text-xs uppercase tracking-wider rounded-lg hover:bg-primary/90 transition-all duration-300 font-semibold cursor-pointer"
          >
            INITIALISE SECURE CHECKOUT
          </button>
        </div>
      </div>
    </div>
    <CheckoutModal
      isOpen={isCheckoutOpen}
      onClose={() => setIsCheckoutOpen(false)}
      productName="LUME001"
      price={38.88}
      currency="gbp"
    />
    </>
  )
}